import type { Data } from '@/api/api'
import type { ChangeManagerData, FeedbackData, ManagerData } from '@/types/managers.types.ts'
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}user-managers/`

export const getManagerInfo = async (): Promise<Data<ManagerData>> => axios.get(`${urlPrefix}info/`)

export const assignManager = async (): Promise<Data<ManagerData>> => {
  const { cookies } = useCookies()

  return axios.post(
    `${urlPrefix}assign/`,
    {},
    {
      headers: {
        'X-CSRFToken': cookies.get('csrftoken'),
      },
    },
  )
}

export const unassignManager = async (payload: ChangeManagerData): Promise<Data<ManagerData>> => {
  const { cookies } = useCookies()

  return axios.post(
    `${urlPrefix}unassign/`,
    { ...payload },
    {
      headers: {
        'X-CSRFToken': cookies.get('csrftoken'),
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

export const changeManager = async (payload: ChangeManagerData): Promise<Data<ManagerData>> => {
  const { cookies } = useCookies()

  return axios.post(
    `${urlPrefix}change/`,
    { ...payload },
    {
      headers: {
        'X-CSRFToken': cookies.get('csrftoken'),
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

export const feedbackManager = async (payload: FeedbackData): Promise<Data<ManagerData>> => {
  const { cookies } = useCookies()

  return axios.post(
    `${urlPrefix}feedback/`,
    { ...payload },
    {
      headers: {
        'X-CSRFToken': cookies.get('csrftoken'),
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}
